/* Stockist menu builder (sections/stockist-menu-builder.liquid).
   One layout engine produces drawing operations in A5 millimetres; the same operations are painted onto
   <canvas> for the live preview and replayed into jsPDF for the download, so the PDF matches the preview. */
(() => {
  const root = document.querySelector('[data-stockist-menu]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-smb-config]').textContent);

  // Menu wording for each product: [name, description]. A product's custom.menu_name /
  // custom.menu_description fields win over these.
  const COPY = {
    'new-style-doggy-doughnuts-box-of-12-trade': ['Doggy Doughnut', 'Peanut butter base with sugar-free icing'],
    'deluxe-doggy-brownies-box-of-9-trade': ['Doggy Brownie', 'Peanut butter, carob & coconut with sugar-free icing'],
    'paw-print-cookies-trade-pre-order-w-c-7th-july': ['Paw Print Cookie', 'Peanut butter, carob & coconut with sugar-free icing'],
    'bakewell-tarts-grain-free-natural-dog-cake-trade': ['Bakewell Tart', 'Peanut butter case, coconut cookie centre & natural icing'],
    'doggy-eclairs-trade': ['Doggy Éclair', 'Peanut butter biscuit bun with a carob ganache topping'],
    'pre-order-cannolis-box-of-10-trade': ['Doggy Cannoli', 'Baked peanut butter shell'],
    'doggy-waffles-trade-pack-of-8': ['Doggy Waffle', 'Natural, grain-free waffle treat'],
    'pizza-slice-wanna-pizza-me-box-of-8-trade': ['Pizza Slice', 'Crunchy peanut butter base with sugar-free vegan icing'],
    'sausage-rolls-trade': ['Sausage Roll', 'Peanut butter & natural meaty flavours – meat-free!'],
    'cheesy-twists-box-of-15-trade': ['‘Cheesy’ Straw Twist', 'Dairy-free cheesy flavour from nutritional yeast'],
    'doggy-truffles-new-trade': ['Doggy Truffle', 'Grain-free & sugar-free'],
    'individual-luxury-pupcake-trade': ['Luxury Pupcake', 'Frosted, grain-free pupcake – ask about today’s flavours'],
    'copy-of-i-woof-you-pupcake-trade': ['Pupcake Selection', 'Blueberry Cream, Eton Mess, Peanut Butter Cup & more'],
    'pawty-pupcake-pack-of-6-new-improved-recipe-trade': ['Pawty Pupcake', 'Peanut butter pupcake, gentle on sensitive tummies'],
    'birthday-pupcake-trade': ['Birthday Pupcake', 'Natural frosting, a peanut butter bone & sugar-free sprinkles'],
    'copy-of-luxury-pupcake-pawty-box-trade-new-lower-price': ['Pupcake Gift Box', 'Four luxury pupcakes in three flavours'],
    'doggy-birthday-cake-trade': ['Dog Birthday Cake', '4” macaroon cake topped with peanut butter frosting'],
    'large-birthday-bones-trade': ['Birthday Bone', 'Peanut butter bone topped with sprinkles'],
    'custom-bones': ['Personalised Bone', 'Peanut butter bone stamped with our own message'],
    'gingerbread-men-box-of-15': ['Gingerbread Man', 'Large, grain-free gingerbread biscuit'],
    'peanut-butter-bones-1': ['Peanut Butter Bones', 'Our classic best-seller'],
    'turmeric-toasties-1': ['Hip & Joint Bones', 'Turmeric, chia seeds & a pinch of black pepper'],
    'minty-breath-bones-1': ['Minty Breath Bones', 'Fresh minty flavour for fresher breath'],
    'minty-dental-sticks-1': ['Daily Dental Sticks', 'Minty sticks to support healthy teeth'],
    'coconut-macaroons-1': ['Coconut Macaroons', 'The original macaroon for dogs'],
    'beetroot-bones-hearts-1': ['Beetroot Kisses', 'Beetroot & pure peanut butter'],
    'bedtime-biccies': ['Bedtime Biccies', 'Chamomile, valerian root, passion flower & fennel'],
    'mini-gingerbread-men-1': ['Mini Gingerbread Men', 'Pure peanut butter & ginger'],
    'mini-cookies': ['Mini ‘Choc’ Chip Cookies', 'Peanut butter & carob chunks'],
    'copy-of-cheesy-training-treats-trade-50-launch-price-24-hours-only': ['Cheesy Training Treats', 'Dairy-free cheesy flavour, perfect for pockets'],
    'diy-doggy-drinks-starbarks-shakes-mixed-case-of-12-trade': ['Starbarks Shake', 'Peanut butter or strawberry ‘milkshake’'],
    'new-flavours-pre-order-ice-cream-case-of-8-tubs-trade': ['Doggy Ice Cream', 'Dairy-free & plant-based – ask about flavours'],
    'treatings-card-happy-birthday-edition-trade-pack-of-6': ['Happy Birthday Treatings Card', 'Greetings card with a hand-baked peanut butter bone'],
    'treatings-card-happy-cake-day-blue-trade-pack-of-6': ['Happy Cake Day Card – Blue', 'Greetings card with a hand-baked peanut butter bone'],
    'treatings-card-happy-cake-day-pink-trade-pack-of-6': ['Happy Cake Day Card – Pink', 'Greetings card with a hand-baked peanut butter bone'],
    'treatings-card-happy-cake-day-pink-trade-pack-of-6-copy': ['Happy Gotcha Day Card', 'Greetings card with a hand-baked peanut butter bone'],
    'treatings-card-woof-you-edition-trade-pack-of-6': ['Woof You Treatings Card', 'Greetings card with a heart-shaped beetroot biscuit'],
    'pre-order-filled-treat-gift-jar-trade': ['Gift Treat Jar', 'Filled with at least 300g of assorted treats'],
    'natural-peanut-butter-pack-of-6': ['Natural Peanut Butter', '100% peanuts, no additives'],
    'pre-order-merry-woofmas-bones-trade': ['Merry Woofmas Bone', 'Hand-stamped festive peanut butter bone'],
    'mince-pies-trade-christmas-pre-order': ['Doggy Mince Pies', 'Peanut butter pastry, carob ‘mincemeat’ & a star topper'],
    'pierre-the-polar-bear-pupcake-trade': ['Pierre the Polar Bear Pupcake', 'Plant-based frosting & coconut sprinkles'],
    'treatings-card-woofmas-christmas-edition-trade-2-designs-copy-1': ['Christmas Roast Dinner Cracker', 'Biscuit carrots, sprouts, roast potatoes & turkey'],
    'dogvent-calendar-2026-trade': ['Dogvent Advent Calendar', 'A treat a day, from minty trees to bedtime biccies'],
    'treatings-card-happy-birthday-edition-trade-pack-of-6-copy': ['Woofmas Treatings Card', 'Festive greetings card with a hand-baked treat'],
    'diy-doggy-drinks-pumpkin-spiced-latte-case-of-12-trade': ['Pumpkin Spiced Latte', 'Organic coconut, maca root, cinnamon & pumpkin'],
    'diy-doggy-drinks-egg-nogg-case-of-12-trade-ready': ['Doggy Egg Nog', 'Organic coconut, maca root & cinnamon'],
    'bag-o-bones-halloween-biccies-copy': ['Bag ’O’ Bones', 'Spooky peanut butter bones & skulls']
  };

  const C = { green: '#365c4b', dark: '#234535', muted: '#566457', gold: '#d9ad55', line: '#d5dacd' };
  const FONT_NAMES = { jss: 'SMB Josefin SemiBold', jsb: 'SMB Josefin Bold', jsi: 'SMB Josefin Italic', rob: 'SMB Roboto' };
  const PT = 0.352778; // mm per point
  const PAGE = { w: 148, h: 210 }; // layout is always done in A5 millimetres
  const SAVE_KEY = 'lorStockistMenu.v1';

  const $ = (sel) => root.querySelector(sel);
  const el = (tag, attrs = {}, kids = []) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (k === 'text') n.textContent = v;
      else if (k.startsWith('on')) n.addEventListener(k.slice(2), v);
      else if (v === true) n.setAttribute(k, '');
      else if (v !== false && v != null) n.setAttribute(k, v);
    }
    [].concat(kids).forEach((c) => c && n.append(c));
    return n;
  };
  const money = (n) => '£' + (Number.isInteger(n) ? n : n.toFixed(2));
  const cleanTitle = (t) => t
    .replace(/\(TRADE\)/gi, '')
    .replace(/[-–]?\s*\b(case|box|pack) of \d+\b/gi, '')
    .replace(/\s{2,}/g, ' ').replace(/[\s\-–]+$/, '').trim();

  /* ---------- state ---------- */
  const state = {
    title: cfg.title,
    note: cfg.footerNote || '',
    size: 'A5',
    logo: { type: 'none', text: '', img: null, data: null, w: 0, h: 0 },
    cats: cfg.cats.map((c) => ({
      id: c.id, title: c.title, tagline: c.tagline || '',
      items: c.items.map((p) => {
        const copy = COPY[p.key] || [];
        return {
          key: p.key,
          name: p.name || copy[0] || cleanTitle(p.title),
          desc: p.desc || copy[1] || '',
          price: p.rrp ? money(Number(p.rrp)) + (p.label ? ' per ' + p.label : '') : '',
          on: !!c.ticked
        };
      })
    })),
    custom: { title: cfg.customTitle, items: [0, 1, 2].map(() => ({ name: '', desc: '', price: '', on: true })) }
  };

  // Saved choices (only when "Remember choices" is switched on in the theme editor).
  const saveState = () => {
    if (!cfg.save) return;
    try {
      const logo = { type: state.logo.type, text: state.logo.text, data: state.logo.data && state.logo.data.length < 1500000 ? state.logo.data : null };
      localStorage.setItem(SAVE_KEY, JSON.stringify({ title: state.title, note: state.note, size: state.size, logo, cats: state.cats, custom: state.custom }));
    } catch (e) { /* storage unavailable */ }
  };
  const loadState = () => {
    if (!cfg.save) return null;
    try {
      const s = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null');
      if (!s) return null;
      state.title = s.title ?? state.title;
      state.note = s.note ?? state.note;
      state.size = s.size || state.size;
      // Only restore items that are still on the menu, so removed products drop out cleanly.
      state.cats.forEach((c) => {
        const sc = (s.cats || []).find((x) => x.id === c.id);
        if (!sc) return;
        c.title = sc.title; c.tagline = sc.tagline;
        c.items.forEach((it) => {
          const si = (sc.items || []).find((x) => x.key === it.key);
          if (si) Object.assign(it, { name: si.name, desc: si.desc, price: si.price, on: si.on });
        });
      });
      if (s.custom) state.custom = s.custom;
      return s.logo || null;
    } catch (e) { return null; }
  };

  /* ---------- fonts & measuring ---------- */
  const measureCtx = document.createElement('canvas').getContext('2d');
  const loadFonts = () => Promise.all(Object.entries(cfg.fonts).map(async ([k, url]) => {
    const face = new FontFace(FONT_NAMES[k], `url(${url})`);
    await face.load();
    document.fonts.add(face);
  }));
  const widthCache = new Map();
  const charW = (s, font) => {
    const k = font + '|' + s;
    if (!widthCache.has(k)) {
      measureCtx.font = `100px "${FONT_NAMES[font]}"`;
      widthCache.set(k, measureCtx.measureText(s).width / 100);
    }
    return widthCache.get(k);
  };
  // Width in mm at a size in points; letter-spaced text is measured (and drawn) one character at a time.
  const textW = (s, font, size, cs = 0) => {
    if (!cs) return charW(s, font) * size * PT;
    let w = 0;
    for (const ch of s) w += charW(ch, font) * size * PT + cs;
    return w - cs;
  };
  const wrap = (s, font, size, maxW) => {
    const words = String(s).trim().split(/\s+/).filter(Boolean);
    const lines = [];
    let line = '';
    for (const w of words) {
      const t = line ? line + ' ' + w : w;
      if (line && textW(t, font, size) > maxW) { lines.push(line); line = w; } else line = t;
    }
    if (line) lines.push(line);
    return lines;
  };

  /* ---------- layout ---------- */
  const M = 11; // page margin
  const FOOT = 15; // footer band height

  function sections() {
    const out = state.cats
      .map((c) => ({ title: c.title, tagline: c.tagline, items: c.items.filter((i) => i.on && i.name.trim()) }))
      .filter((c) => c.items.length);
    const own = state.custom.items.filter((i) => i.on && i.name.trim());
    if (own.length) out.push({ title: state.custom.title, tagline: '', items: own });
    return out;
  }

  // Life of Riley badge in the top-right corner; the centred header items are kept clear of it.
  const BADGE = 23;
  const headW = () => PAGE.w - 2 * (M + (brand.img ? BADGE + 2 : 0));

  function headerOps(f) {
    const ops = [];
    let y = M + 2;
    const lg = state.logo;
    if (brand.img) {
      const bh = BADGE * brand.h / brand.w;
      const bx = PAGE.w - M - BADGE + 2;
      ops.push({ k: 'img', brand: true, x: bx, y: M - 2, w: BADGE, h: bh });
      const cap = (cfg.badgeCaption || '').trim();
      if (cap) {
        const lines = wrap(cap, 'jsi', 6.8, BADGE + 6);
        lines.forEach((l, i) => ops.push({ k: 'text', font: 'jsi', size: 6.8, color: C.green, text: l, center: bx + BADGE / 2, y: M - 2 + bh + 3 + i * 2.8 }));
      }
    }
    if (lg.type === 'image' && lg.img) {
      const maxW = Math.min(56, headW()), maxH = 22 * f;
      const r = Math.min(maxW / lg.w, maxH / lg.h);
      const w = lg.w * r, h = lg.h * r;
      ops.push({ k: 'img', x: (PAGE.w - w) / 2, y, w, h });
      y += h + 5;
    } else if (lg.type === 'text' && lg.text.trim()) {
      // Wrap long names onto extra lines (up to 4) before shrinking the text.
      const given = lg.text.toUpperCase().split(/\n/).map((s) => s.trim()).filter(Boolean).slice(0, 3);
      const fits = (sz, ls) => ls.every((l) => textW(l, 'jsb', sz, 0.3 * sz / 20) <= headW());
      let size = 20 * f, lines = given;
      for (; size > 9; size -= 0.5) {
        lines = given.flatMap((l) => wrap(l, 'jsb', size * 1.04, headW()));
        if (lines.length <= 4 && fits(size, lines)) break;
      }
      if (!fits(size, lines)) size = Math.min(size, ...lines.map((l) => size * headW() / textW(l, 'jsb', size, 0.3 * size / 20)));
      const lh = size * PT * 1.1;
      lines.forEach((l) => {
        y += size * PT * 0.8;
        ops.push({ k: 'text', font: 'jsb', size, color: C.dark, text: l, cs: 0.3 * size / 20, center: PAGE.w / 2, y });
        y += lh - size * PT * 0.8;
      });
      y += 5;
    }
    const title = state.title.trim();
    if (title) {
      const size = Math.min(26 * f, headW() / Math.max(textW(title, 'jss', 1), 1));
      y += size * PT * 0.78;
      ops.push({ k: 'text', font: 'jss', size, color: C.green, text: title, center: PAGE.w / 2, y });
      y += Math.max(3.2, size * PT * 0.38); // clear the descenders
      ops.push({ k: 'line', x1: PAGE.w / 2 - 9, y1: y, x2: PAGE.w / 2 + 9, y2: y, color: C.gold, w: 0.6 });
      y += 6 * f;
    }
    return { ops, y };
  }

  // Fixed allergy & ingredients box above the footer (set in the theme editor, stockists can't change it).
  const NOTICE_H = 9.5;
  const hasNotice = () => !!((cfg.noticeHeading || '').trim() || (cfg.noticeText || '').trim());

  function footerOps() {
    const ops = [];
    const yRule = PAGE.h - M - FOOT + 3;
    if (hasNotice()) {
      // Compact box sized to its text; 7pt minimum so it stays legible in print.
      const head = (cfg.noticeHeading || '').trim().toUpperCase(), text = (cfg.noticeText || '').trim();
      const HS = 7.2, TS = 7;
      const inner = PAGE.w - 2 * M - 6;
      const w = Math.min(PAGE.w - 2 * M, Math.max(head ? textW(head, 'jsb', HS, 0.2) : 0, text ? textW(text, 'jsi', TS) : 0) + 10);
      const h = head && text ? NOTICE_H : 6.5;
      const top = yRule - (state.note.trim() ? 6.5 : 2.5) - h;
      ops.push({ k: 'rect', x: (PAGE.w - w) / 2, y: top, w, h, r: 1.6, fill: '#fbf8eb', stroke: C.gold, lw: 0.35 });
      if (head) ops.push({ k: 'text', font: 'jsb', size: HS, color: C.green, text: head, cs: 0.2, center: PAGE.w / 2, y: top + (text ? 3.9 : 4.3), maxW: inner });
      if (text) ops.push({ k: 'text', font: 'jsi', size: TS, color: C.dark, text, center: PAGE.w / 2, y: top + (head ? 7.4 : 4.3), maxW: inner });
    }
    if (state.note.trim()) {
      ops.push({ k: 'text', font: 'jsi', size: 7.5, color: C.muted, text: state.note.trim(), center: PAGE.w / 2, y: yRule - 2.2, maxW: PAGE.w - 2 * M });
    }
    ops.push({ k: 'line', x1: M + 20, y1: yRule, x2: PAGE.w - M - 20, y2: yRule, color: C.line, w: 0.25 });
    const credit = cfg.credit || '';
    if (credit) ops.push({ k: 'text', font: 'rob', size: 6.6, color: C.muted, text: credit, center: PAGE.w / 2, y: yRule + 4.5, maxW: PAGE.w - 2 * M });
    return ops;
  }

  // Lays the menu out at font scale f in `cols` columns. colBottom (optional) caps the column height
  // on the first page, which is used to balance two short columns.
  function layout(f, cols, colBottom) {
    const head = headerOps(f);
    const foot = footerOps();
    const gap = 8;
    const colW = (PAGE.w - 2 * M - (cols - 1) * gap) / cols;
    const bottom = PAGE.h - M - FOOT - (state.note.trim() ? 6 : 1) - (hasNotice() ? NOTICE_H + 3 : 0);
    const S = { head: 11 * f, tag: 7.8 * f, name: 9.4 * f, desc: 7.2 * f };
    const LH = { head: S.head * PT * 1.25, tag: S.tag * PT * 1.3, name: S.name * PT * 1.25, desc: S.desc * PT * 1.3 };

    // Measure every block first.
    const blocks = [];
    sections().forEach((sec, si) => {
      const tag = sec.tagline.trim() ? wrap(sec.tagline, 'jsi', S.tag, colW) : [];
      blocks.push({ type: 'head', sec, tag, h: (si ? 4.5 * f : 0) + LH.head + tag.length * LH.tag + 2.4 * f, first: si === 0 });
      sec.items.forEach((it) => {
        const price = it.price.trim();
        const pw = price ? textW(price, 'jss', S.name) + 3 : 0;
        const nameLines = wrap(it.name, 'jss', S.name, colW - pw);
        const descLines = it.desc.trim() ? wrap(it.desc, 'rob', S.desc, colW - (cols === 1 ? 14 : 2)) : [];
        blocks.push({ type: 'item', it, price, nameLines, descLines, h: nameLines.length * LH.name + descLines.length * LH.desc + 2.3 * f });
      });
    });

    const pages = [];
    let page, col, y, top;
    const newPage = () => {
      page = { ops: [], content: [] };
      pages.push(page);
      top = pages.length === 1 ? head.y : M + 2;
      col = 0; y = top;
    };
    newPage();
    const colLimit = () => (pages.length === 1 && colBottom ? Math.min(colBottom, bottom) : bottom);
    const advance = () => {
      if (col < cols - 1) { col++; y = top; } else newPage();
    };

    for (let i = 0; i < blocks.length; i++) {
      const b = blocks[i];
      let need = b.h;
      if (b.type === 'head' && blocks[i + 1]) need += blocks[i + 1].h; // keep heading with its first item
      if (y !== top && y + need > colLimit()) advance();
      const x = M + col * (colW + gap);
      const ops = page.content;
      if (b.type === 'head') {
        if (y !== top) y += 4.5 * f; // gap between sections, but not at the top of a column
        y += S.head * PT * 0.85;
        ops.push({ k: 'text', font: 'jsb', size: S.head, color: C.green, text: b.sec.title.toUpperCase(), cs: 0.45 * f, center: x + colW / 2, y });
        y += LH.head - S.head * PT * 0.85;
        b.tag.forEach((l) => {
          y += S.tag * PT * 0.9;
          ops.push({ k: 'text', font: 'jsi', size: S.tag, color: C.muted, text: l, center: x + colW / 2, y });
          y += LH.tag - S.tag * PT * 0.9;
        });
        y += 2.4 * f;
      } else {
        const right = x + colW;
        b.nameLines.forEach((l, li) => {
          y += S.name * PT * 0.85;
          ops.push({ k: 'text', font: 'jss', size: S.name, color: C.dark, text: l, x, y });
          if (li === b.nameLines.length - 1 && b.price) {
            const pw = textW(b.price, 'jss', S.name);
            const nameEnd = x + textW(l, 'jss', S.name) + 1.6;
            const priceStart = right - pw - 1.6;
            if (priceStart - nameEnd > 3) ops.push({ k: 'line', x1: nameEnd, y1: y - 0.35, x2: priceStart, y2: y - 0.35, color: C.line, w: 0.35, dash: [0.25, 1] });
            ops.push({ k: 'text', font: 'jss', size: S.name, color: C.green, text: b.price, x: right - pw, y });
          }
          y += LH.name - S.name * PT * 0.85;
        });
        b.descLines.forEach((l) => {
          y += S.desc * PT * 0.85;
          ops.push({ k: 'text', font: 'rob', size: S.desc, color: C.muted, text: l, x, y });
          y += LH.desc - S.desc * PT * 0.85;
        });
        y += 2.3 * f;
      }
      page.maxY = Math.max(page.maxY || 0, y);
    }

    // Single page with room to spare: centre the menu in the space between title and footer.
    if (pages.length === 1 && page.maxY) {
      const spare = bottom - page.maxY;
      if (spare > 4) {
        const dy = Math.min(spare / 2, 18);
        page.content.forEach((o) => { o.y += dy; if (o.y1 != null) { o.y1 += dy; o.y2 += dy; } });
      }
    }
    pages.forEach((p, i) => {
      p.ops = [...(i === 0 ? head.ops : []), ...p.content, ...foot];
    });
    return { pages, overflow: pages.length > 1, maxY: pages[0].maxY || head.y, bottom, cols };
  }

  // One column while the text can stay near full size, otherwise two columns, otherwise extra pages.
  function bestLayout() {
    for (let f = 1.3; f >= 0.899; f -= 0.05) { // short menus get larger text
      const l = layout(f, 1);
      if (!l.overflow) return l;
    }
    for (let f = 1; f >= 0.699; f -= 0.05) {
      const l = layout(f, 2);
      if (!l.overflow) {
        // Balance the two columns: shrink the column height until the menu no longer fits.
        let lo = layout(f, 2).maxY * 0.4, hi = l.bottom, best = l;
        for (let n = 0; n < 12; n++) {
          const mid = (lo + hi) / 2;
          const t = layout(f, 2, mid);
          if (t.overflow) lo = mid; else { hi = mid; best = t; }
        }
        return best;
      }
    }
    return layout(0.8, 2);
  }

  /* ---------- painting ---------- */
  const brand = { img: null, data: null, w: 1, h: 1 };

  function paintCanvas(canvas, ops, pxPerMm) {
    const ctx = canvas.getContext('2d');
    const k = pxPerMm;
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.textBaseline = 'alphabetic';
    for (const o of ops) {
      if (o.k === 'text') {
        ctx.fillStyle = o.color;
        ctx.font = `${o.size * PT * k}px "${FONT_NAMES[o.font]}"`;
        textRuns(o).forEach(([s, x]) => ctx.fillText(s, x * k, o.y * k));
      } else if (o.k === 'rect') {
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(o.x * k, o.y * k, o.w * k, o.h * k, o.r * k); else ctx.rect(o.x * k, o.y * k, o.w * k, o.h * k);
        ctx.fillStyle = o.fill; ctx.fill();
        ctx.strokeStyle = o.stroke; ctx.lineWidth = o.lw * k; ctx.stroke();
      } else if (o.k === 'line') {
        ctx.strokeStyle = o.color; ctx.lineWidth = o.w * k;
        ctx.lineCap = o.dash ? 'round' : 'butt';
        ctx.setLineDash((o.dash || []).map((d) => d * k));
        ctx.beginPath(); ctx.moveTo(o.x1 * k, o.y1 * k); ctx.lineTo(o.x2 * k, o.y2 * k); ctx.stroke();
        ctx.setLineDash([]);
      } else if (o.k === 'img') {
        const im = o.brand ? brand.img : state.logo.img;
        if (im) ctx.drawImage(im, o.x * k, o.y * k, o.w * k, o.h * k);
      }
    }
  }

  // Resolves a text op into [string, x] runs: one run normally, one per character when letter-spaced.
  function textRuns(o) {
    let s = o.text;
    if (o.maxW) while (s.length > 4 && textW(s, o.font, o.size, o.cs) > o.maxW) s = s.slice(0, -2) + '…';
    const w = textW(s, o.font, o.size, o.cs || 0);
    let x = o.center != null ? o.center - w / 2 : o.x;
    if (!o.cs) return [[s, x]];
    const runs = [];
    for (const ch of s) { runs.push([ch, x]); x += textW(ch, o.font, o.size) + o.cs; }
    return runs;
  }

  /* ---------- preview ---------- */
  const preview = $('[data-smb-preview]');
  const fitMsg = $('[data-smb-fit]');
  let current = null;
  let raf = 0;
  function render() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      current = bestLayout();
      const cssW = Math.max(220, preview.clientWidth || 360);
      const dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      const pxPerMm = (cssW * dpr) / PAGE.w;
      preview.replaceChildren(...current.pages.map((p, i) => {
        const cv = el('canvas', { class: 'smb__page', role: 'img', 'aria-label': `Menu preview, page ${i + 1}` });
        cv.width = Math.round(PAGE.w * pxPerMm);
        cv.height = Math.round(PAGE.h * pxPerMm);
        paintCanvas(cv, p.ops, pxPerMm);
        return cv;
      }));
      const n = sections().reduce((a, s) => a + s.items.length, 0);
      fitMsg.textContent = !n ? 'Tick some treats to add them to your menu.'
        : current.overflow ? `${current.pages.length} pages – untick a few items to fit everything on one page.`
        : `${n} item${n === 1 ? '' : 's'} – fits on one page.`;
      fitMsg.classList.toggle('smb__fit--warn', current.overflow);
      saveState();
    });
  }

  /* ---------- PDF ---------- */
  const scripts = {};
  const loadScript = (src) => scripts[src] || (scripts[src] = new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = res;
    s.onerror = () => { delete scripts[src]; rej(new Error('Could not load the PDF tool')); };
    document.head.append(s);
  }));
  // jsPDF and the TrueType copies of the fonts only load when someone makes a PDF.
  const loadJsPDF = async () => {
    await Promise.all([window.jspdf || loadScript(cfg.jspdf), window.SMB_PDF_FONTS || loadScript(cfg.pdfFonts)]);
    return window.jspdf;
  };

  async function buildPdf() {
    const { jsPDF } = await loadJsPDF();
    const lay = current || bestLayout();
    const size = state.size;
    const doc = size === 'A5' ? new jsPDF({ unit: 'mm', format: 'a5', compress: true })
      : size === 'A4' ? new jsPDF({ unit: 'mm', format: 'a4', compress: true })
      : new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape', compress: true });
    for (const [k, data] of Object.entries(window.SMB_PDF_FONTS)) {
      doc.addFileToVFS(k + '.ttf', data);
      doc.addFont(k + '.ttf', k, 'normal');
    }
    // Where each A5 copy goes on the sheet: [offsetX, offsetY, scale].
    const placements = size === 'A5' ? [[0, 0, 1]]
      : size === 'A4' ? [[(210 - PAGE.w * (297 / 210)) / 2, 0, 297 / 210]]
      : [[0, 0, 1], [148.5, 0, 1]];
    lay.pages.forEach((p, pi) => {
      if (pi) doc.addPage();
      placements.forEach(([ox, oy, u]) => {
        for (const o of p.ops) {
          if (o.k === 'text') {
            doc.setFont(o.font, 'normal');
            doc.setFontSize(o.size * u);
            doc.setTextColor(o.color);
            textRuns(o).forEach(([s, x]) => doc.text(s, ox + x * u, oy + o.y * u));
          } else if (o.k === 'rect') {
            doc.setFillColor(o.fill); doc.setDrawColor(o.stroke); doc.setLineWidth(o.lw * u);
            doc.setLineDashPattern([], 0);
            doc.roundedRect(ox + o.x * u, oy + o.y * u, o.w * u, o.h * u, o.r * u, o.r * u, 'FD');
          } else if (o.k === 'line') {
            doc.setDrawColor(o.color);
            doc.setLineWidth(o.w * u);
            doc.setLineCap(o.dash ? 'round' : 'butt');
            doc.setLineDashPattern(o.dash ? o.dash.map((d) => d * u) : [], 0);
            doc.line(ox + o.x1 * u, oy + o.y1 * u, ox + o.x2 * u, oy + o.y2 * u);
            doc.setLineDashPattern([], 0);
          } else if (o.k === 'img') {
            const data = o.brand ? brand.data : state.logo.data;
            if (data) doc.addImage(data, 'PNG', ox + o.x * u, oy + o.y * u, o.w * u, o.h * u, o.brand ? 'brand' : 'logo');
          }
        }
      });
      if (size === 'A5x2') {
        doc.setDrawColor('#bbbbbb'); doc.setLineWidth(0.2); doc.setLineDashPattern([2, 2], 0);
        doc.line(148.5, 4, 148.5, 206);
        doc.setLineDashPattern([], 0);
      }
    });
    return doc;
  }

  const fileName = () => {
    const base = (state.logo.type === 'text' && state.logo.text.trim()) ? state.logo.text.trim() + ' dog menu' : 'dog menu';
    return base.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '-' + state.size.toLowerCase() + '.pdf';
  };

  const status = $('[data-smb-status]');
  $('[data-smb-download]').addEventListener('click', async (e) => {
    const btn = e.currentTarget;
    if (!sections().length) { status.textContent = 'Tick at least one treat first.'; return; }
    btn.disabled = true; status.textContent = 'Making your PDF…';
    try {
      const doc = await buildPdf();
      doc.save(fileName());
      status.textContent = 'Downloaded – check your downloads folder.';
    } catch (err) {
      console.error(err);
      status.textContent = 'Sorry, the PDF could not be made. Please try again or contact us.';
    } finally { btn.disabled = false; }
  });

  root.querySelectorAll('.smb__sizes input').forEach((r) => {
    r.checked = r.value === state.size;
    r.addEventListener('change', () => { state.size = r.value; saveState(); });
  });

  /* ---------- printed menus by post (hidden unless switched on) ---------- */
  const postBtn = $('[data-smb-post]');
  if (postBtn && cfg.print) {
    const postStatus = $('[data-smb-post-status]');
    postBtn.addEventListener('click', async () => {
      if (!sections().length) { postStatus.textContent = 'Tick at least one treat first.'; return; }
      const qty = Math.max(1, Math.min(cfg.print.max || 50, parseInt($('[data-smb-post-qty]').value, 10) || 1));
      postBtn.disabled = true; postStatus.textContent = 'Adding to your basket…';
      try {
        const doc = await buildPdf();
        const pdf = new File([doc.output('blob')], fileName(), { type: 'application/pdf' });
        const fd = new FormData();
        fd.append('id', cfg.print.variant);
        fd.append('quantity', qty);
        fd.append('properties[Menu PDF]', pdf);
        fd.append('properties[Paper size]', state.size === 'A5x2' ? '2 x A5 on A4' : state.size);
        fd.append('properties[_Menu items]', sections().map((s) => s.title + ': ' + s.items.map((i) => i.name + (i.price ? ' ' + i.price : '')).join(', ')).join(' | ').slice(0, 2000));
        if (state.logo.type === 'image' && state.logo.file) fd.append('properties[Logo]', state.logo.file);
        if (state.logo.type === 'text' && state.logo.text.trim()) fd.append('properties[Business name]', state.logo.text.trim());
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Add to basket failed');
        postStatus.replaceChildren('Added to your basket. ', el('a', { href: (window.routes && window.routes.cart_url) || '/cart', text: 'View basket' }));
      } catch (err) {
        console.error(err);
        postStatus.textContent = 'Sorry, that did not work: ' + err.message;
      } finally { postBtn.disabled = false; }
    });
  }

  /* ---------- controls ---------- */
  const imageToPng = (src) => new Promise((res, rej) => {
    const im = new Image();
    im.onload = () => {
      const scale = Math.min(1, 1600 / Math.max(im.naturalWidth, im.naturalHeight));
      const cv = document.createElement('canvas');
      cv.width = Math.max(1, Math.round(im.naturalWidth * scale));
      cv.height = Math.max(1, Math.round(im.naturalHeight * scale));
      cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
      const data = cv.toDataURL('image/png');
      const out = new Image();
      out.onload = () => res({ img: out, data, w: cv.width, h: cv.height });
      out.onerror = rej;
      out.src = data;
    };
    im.onerror = () => rej(new Error('That image could not be read'));
    im.src = src;
  });

  function buildControls() {
    const box = $('[data-smb-controls]');
    const input = (value, onInput, attrs = {}) => el('input', { type: 'text', value, ...attrs, oninput: (e) => { onInput(e.target.value); render(); } });

    // 1. Logo
    const logoPreview = el('div', { class: 'smb__logo-preview' });
    const showLogo = () => {
      const lg = state.logo;
      logoPreview.replaceChildren(lg.type === 'image' && lg.img
        ? el('img', { src: lg.data, alt: 'Your logo' })
        : el('span', { text: lg.type === 'text' && lg.text.trim() ? lg.text : 'No logo yet' }));
    };
    const fileInput = el('input', { type: 'file', accept: 'image/png,image/jpeg', class: 'smb__file', id: 'smb-logo-file' });
    const logoErr = el('p', { class: 'smb__error', 'aria-live': 'polite' });
    fileInput.addEventListener('change', async () => {
      const file = fileInput.files[0];
      logoErr.textContent = '';
      if (!file) return;
      if (file.size > 15 * 1024 * 1024) { logoErr.textContent = 'That file is over 15MB – please use a smaller image.'; return; }
      try {
        const url = URL.createObjectURL(file);
        const r = await imageToPng(url);
        URL.revokeObjectURL(url);
        Object.assign(state.logo, { type: 'image', file, ...r });
        textArea.value = '';
        showLogo(); render();
      } catch (e) { logoErr.textContent = 'Sorry, that image could not be read. Please use a JPG or PNG.'; }
    });
    const textArea = el('textarea', { rows: 2, placeholder: 'YOUR BUSINESS NAME', class: 'smb__logo-text', 'aria-label': 'Business name' });
    textArea.addEventListener('input', () => {
      Object.assign(state.logo, { type: textArea.value.trim() ? 'text' : 'none', text: textArea.value, img: null, data: null, file: null });
      fileInput.value = '';
      showLogo(); render();
    });
    const removeBtn = el('button', { type: 'button', class: 'smb__link', text: 'Remove logo', onclick: () => {
      Object.assign(state.logo, { type: 'none', text: '', img: null, data: null, file: null });
      fileInput.value = ''; textArea.value = ''; logoErr.textContent = '';
      showLogo(); render();
    } });

    box.append(el('div', { class: 'smb__step' }, [
      el('h2', { class: 'smb__step-title', text: '1. Your logo' }),
      el('div', { class: 'smb__logo-row' }, [
        logoPreview,
        el('div', { class: 'smb__logo-actions' }, [
          fileInput,
          el('label', { for: 'smb-logo-file', class: 'button button--secondary smb__upload', text: 'Upload logo' }),
          el('p', { class: 'smb__small', text: 'JPG or PNG on a white or transparent background works best.' })
        ])
      ]),
      logoErr,
      el('p', { class: 'smb__or', text: 'or type your business name' }),
      textArea,
      removeBtn
    ]));

    // 2. Title & note
    box.append(el('div', { class: 'smb__step' }, [
      el('h2', { class: 'smb__step-title', text: '2. Menu title & note' }),
      el('label', { class: 'smb__field' }, [el('span', { text: 'Title' }), input(state.title, (v) => { state.title = v; }, { maxlength: 40 })]),
      el('label', { class: 'smb__field' }, [el('span', { text: 'Note at the bottom' }), input(state.note, (v) => { state.note = v; }, { maxlength: 90 })])
    ]));

    // 3. Treats
    const itemRow = (it) => {
      const wording = el('div', { class: 'smb__wording', hidden: true }, [
        el('label', { class: 'smb__field' }, [el('span', { text: 'Name on menu' }), input(it.name, (v) => { it.name = v; nameLabel.textContent = v || '(no name)'; }, { maxlength: 60 })]),
        el('label', { class: 'smb__field' }, [el('span', { text: 'Description' }), input(it.desc, (v) => { it.desc = v; }, { maxlength: 90 })])
      ]);
      const nameLabel = el('span', { class: 'smb__name', text: it.name });
      const cb = el('input', { type: 'checkbox', checked: it.on, onchange: (e) => { it.on = e.target.checked; row.classList.toggle('is-on', it.on); render(); } });
      const row = el('div', { class: 'smb__item' + (it.on ? ' is-on' : '') }, [
        el('label', { class: 'smb__check' }, [cb, el('span', {}, [nameLabel, it.desc ? el('small', { text: it.desc }) : null])]),
        el('input', { type: 'text', class: 'smb__price', value: it.price, placeholder: '£', 'aria-label': `Price for ${it.name}`, maxlength: 24, oninput: (e) => { it.price = e.target.value; render(); } }),
        el('button', { type: 'button', class: 'smb__link smb__edit', text: 'Edit wording', 'aria-expanded': 'false', onclick: (e) => {
          wording.hidden = !wording.hidden;
          e.target.setAttribute('aria-expanded', String(!wording.hidden));
        } }),
        wording
      ]);
      row._cb = cb;
      return row;
    };

    const catBoxes = state.cats.map((c) => {
      const rows = c.items.map(itemRow);
      const count = el('span', { class: 'smb__count' });
      const updCount = () => { count.textContent = `${c.items.filter((i) => i.on).length} of ${c.items.length}`; };
      updCount();
      const setAll = (on) => { c.items.forEach((it, i) => { it.on = on; rows[i]._cb.checked = on; rows[i].classList.toggle('is-on', on); }); updCount(); render(); };
      const det = el('details', { class: 'smb__cat', open: c.items.some((i) => i.on) }, [
        el('summary', {}, [el('span', { class: 'smb__cat-title', text: c.title }), count]),
        el('div', { class: 'smb__cat-body' }, [
          el('div', { class: 'smb__cat-tools' }, [
            el('button', { type: 'button', class: 'smb__link', text: 'Tick all', onclick: () => setAll(true) }),
            el('button', { type: 'button', class: 'smb__link', text: 'Untick all', onclick: () => setAll(false) })
          ]),
          el('div', { class: 'smb__cat-edit' }, [
            el('label', { class: 'smb__field' }, [el('span', { text: 'Section heading' }), input(c.title, (v) => { c.title = v; }, { maxlength: 40 })]),
            el('label', { class: 'smb__field' }, [el('span', { text: 'Tagline' }), input(c.tagline, (v) => { c.tagline = v; }, { maxlength: 90 })])
          ]),
          ...rows
        ])
      ]);
      det.addEventListener('change', updCount);
      return det;
    });

    const own = state.custom;
    const ownRows = own.items.map((it, i) => el('div', { class: 'smb__own' }, [
      el('label', { class: 'smb__field' }, [el('span', { text: `Item ${i + 1}` }), input(it.name, (v) => { it.name = v; }, { maxlength: 60, placeholder: 'e.g. Puppuccino' })]),
      el('label', { class: 'smb__field' }, [el('span', { text: 'Description' }), input(it.desc, (v) => { it.desc = v; }, { maxlength: 90, placeholder: 'Optional' })]),
      el('label', { class: 'smb__field smb__field--price' }, [el('span', { text: 'Price' }), input(it.price, (v) => { it.price = v; }, { maxlength: 24, placeholder: '£' })])
    ]));
    const ownBox = el('details', { class: 'smb__cat', open: own.items.some((i) => i.name.trim()) }, [
      el('summary', {}, [el('span', { class: 'smb__cat-title', text: 'Your own items' }), el('span', { class: 'smb__count', text: 'optional' })]),
      el('div', { class: 'smb__cat-body' }, [
        el('p', { class: 'smb__small', text: 'Add anything else you serve dogs, like a puppuccino or sausage.' }),
        el('label', { class: 'smb__field' }, [el('span', { text: 'Section heading' }), input(own.title, (v) => { own.title = v; }, { maxlength: 40 })]),
        ...ownRows
      ])
    ]);

    box.append(el('div', { class: 'smb__step' }, [
      el('h2', { class: 'smb__step-title', text: '3. Choose your treats' }),
      el('a', { href: '#' + root.id + '-preview', class: 'smb__jump', text: 'See preview & download ↓' }),
      el('p', { class: 'smb__small', text: 'Prices start at our suggested retail prices – change them to whatever you charge.' }),
      ...catBoxes,
      ownBox
    ]));

    if (cfg.save) {
      box.append(el('p', { class: 'smb__small' }, [
        'Your choices are remembered on this device. ',
        el('button', { type: 'button', class: 'smb__link', text: 'Start again', onclick: () => { try { localStorage.removeItem(SAVE_KEY); } catch (e) {} location.reload(); } })
      ]));
    }

    if (state.logo.type === 'text') textArea.value = state.logo.text;
    showLogo();
    return showLogo;
  }

  /* ---------- start ---------- */
  (async () => {
    const savedLogo = loadState();
    try {
      await loadFonts();
    } catch (e) {
      preview.replaceChildren(el('p', { class: 'smb__error', text: 'Sorry, the menu builder could not load. Please refresh the page.' }));
      return;
    }
    if (cfg.brandLogo) {
      try { Object.assign(brand, await imageToPng(cfg.brandLogo)); } catch (e) { /* menu works without the credit logo */ }
    }
    if (savedLogo) {
      if (savedLogo.type === 'image' && savedLogo.data) {
        try { Object.assign(state.logo, { type: 'image', ...(await imageToPng(savedLogo.data)) }); } catch (e) {}
      } else if (savedLogo.type === 'text') Object.assign(state.logo, { type: 'text', text: savedLogo.text || '' });
    }
    buildControls();
    render();
    let lastW = preview.clientWidth;
    new ResizeObserver(() => { if (Math.abs(preview.clientWidth - lastW) > 4) { lastW = preview.clientWidth; render(); } }).observe(preview);
  })();
})();
